import CompanyUserEditForm from '@features/tenant/company-user/CompanyUserEditForm.tsx';
import CommonHelmet from '@src/components/CommonHelmet';
import TenantRoleGuard from '@src/components/guard/TenantRoleGuard';
import { TENANT_ROLE } from '@src/enum/tenantRoleEnum';
import TenantDefaultLayout from '@src/layouts/tenant/TenantDefaultLayout';

function CompanyUserEdit() {
  return (
    <TenantRoleGuard canRoles={[TENANT_ROLE.ADMIN]}>
      <TenantDefaultLayout>
        <CommonHelmet />
        <CompanyUserEditForm />
      </TenantDefaultLayout>
    </TenantRoleGuard>
  );
}

export default CompanyUserEdit;
